import styled from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
`;

export const PageTitle = styled.h1`
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
`;

export const PageSubtitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  color: #4b5563;
  margin: 0;
`;

export const PageSection = styled.section`
  margin-bottom: 2rem;
`;

export const PageSectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #4b5563;
  margin: 0 0 1rem 0;
`; 